/* Janma — Modern Apothecary · shared interactions (prototype) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Year ---- */
  var yr = document.getElementById('yr');
  if (yr) yr.textContent = new Date().getFullYear();

  /* ---- Announcement rotator ---- */
  var announce = document.getElementById('announce');
  if (announce && !reduce) {
    var msgs = announce.querySelectorAll('.announce__msg');
    if (msgs.length > 1) {
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, 4200);
    }
  }

  /* ---- Header: solid + transparent toggle on scroll ---- */
  var header = document.getElementById('header');
  if (header) {
    var hasHero = !!document.querySelector('.hero');
    var onScroll = function () {
      if (window.scrollY > 30 || !hasHero) {
        header.classList.add('site-header--solid');
        header.classList.remove('site-header--transparent');
      } else {
        header.classList.remove('site-header--solid');
        header.classList.add('site-header--transparent');
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Focus management (shared by drawers + modal) ---- */
  var _lastFocused = null, _trapFn = null, _trapPanel = null;
  function _focusables(c) {
    return [].slice.call(c.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null; });
  }
  function startTrap(panel) {
    if (!panel) return;
    _lastFocused = document.activeElement;
    _trapPanel = panel;
    _trapFn = function (e) {
      if (e.key !== 'Tab') return;
      var f = _focusables(panel); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    panel.addEventListener('keydown', _trapFn);
    var f = _focusables(panel); if (f.length) setTimeout(function () { f[0].focus(); }, 30);
  }
  function endTrap() {
    if (_trapFn && _trapPanel) _trapPanel.removeEventListener('keydown', _trapFn);
    _trapFn = null; _trapPanel = null;
    if (_lastFocused && _lastFocused.focus) { try { _lastFocused.focus(); } catch (e) {} }
    _lastFocused = null;
  }

  /* ---- Drawers (cart + mobile nav) ---- */
  var overlay = document.getElementById('overlay');
  var cartDrawer = document.getElementById('cartDrawer');
  var mobileNav = document.getElementById('mobileNav');

  function openDrawer(d) {
    if (!d) return;
    d.inert = false;
    d.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    startTrap(d);
  }
  function closeDrawers() {
    var wasOpen = (cartDrawer && cartDrawer.classList.contains('is-open')) || (mobileNav && mobileNav.classList.contains('is-open'));
    if (cartDrawer) { cartDrawer.classList.remove('is-open'); cartDrawer.inert = true; }
    if (mobileNav) { mobileNav.classList.remove('is-open'); mobileNav.inert = true; }
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (wasOpen) endTrap();
  }

  var cartOpen = document.getElementById('cartOpen');
  if (cartOpen) cartOpen.addEventListener('click', function () { openDrawer(cartDrawer); });
  var menuToggle = document.getElementById('menuToggle');
  if (menuToggle) menuToggle.addEventListener('click', function () { openDrawer(mobileNav); });
  if (overlay) overlay.addEventListener('click', closeDrawers);
  document.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', closeDrawers); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });
  // close mobile nav when navigating to an in-page anchor
  document.querySelectorAll('.mnav a').forEach(function (a) { a.addEventListener('click', closeDrawers); });

  /* Quick-add is handled by cart.js (real AJAX add via [data-add-variant]).
     The old prototype [data-add] fake-add handler was removed to prevent ghost adds. */

  /* ---- Reveal on scroll ---- */
  var revealEls = document.querySelectorAll('.reveal, .reveal-stagger');
  if (reduce || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  /* ---- Count-up ---- */
  var counters = document.querySelectorAll('[data-countup]');
  if (counters.length) {
    var fmt = function (n) { return n.toLocaleString('en-IN'); };
    var run = function (el) {
      var target = parseInt(el.getAttribute('data-countup'), 10) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      if (reduce) { el.textContent = fmt(target) + suffix; return; }
      var start = performance.now(), dur = 1400;
      var step = function (t) {
        var p = Math.min((t - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(Math.round(target * eased)) + suffix;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if ('IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); cio.unobserve(e.target); } });
      }, { threshold: 0.6 });
      counters.forEach(function (el) { cio.observe(el); });
    } else { counters.forEach(run); }
  }

  /* ---- WhatsApp button — reveal only after 1 min on the page ---- */
  var waBtn = document.querySelector('.wa-float');
  if (waBtn) { setTimeout(function () { waBtn.classList.add('is-ready'); }, 60000); }

  /* ---- Offers popup (once per session) — exit-intent + mobile scroll-up + delayed fallback ---- */
  var exit = document.getElementById('exitModal');
  var seen = false;
  try { seen = sessionStorage.getItem('janmaOffer') === '1'; } catch (e) {}
  if (exit && !seen) {
    var shown = false;
    var show = function () {
      if (shown) return; shown = true;
      try { sessionStorage.setItem('janmaOffer', '1'); } catch (e) {}
      exit.inert = false;
      exit.classList.add('is-open');
      startTrap(exit);
    };
    var close = function () { exit.classList.remove('is-open'); exit.inert = true; endTrap(); };
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) show(); });
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      if (window.innerWidth < 760 && window.scrollY < lastY - 50 && window.scrollY > 700) show();
      lastY = window.scrollY;
    }, { passive: true });
    setTimeout(show, 15000); // fallback so the offer surfaces even without an exit gesture
    exit.addEventListener('click', function (e) { if (e.target === exit) close(); });
    exit.querySelectorAll('[data-exit-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }
})();
